export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s não foi escolhido';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s não pode estar em branco';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s é um campo obrigatório';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s não foi corretamente preenchido';
                break;

            case 'opt-in':
                translation = 'Verifique a caixa para continuar';
                break;

            default:
                translation = 'Este campo não foi corretamente preenchido';
                break;
        }

        return translation;
    }
}
